import React from 'react'
import {Card, CardHeader, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from 'reactstrap'
import classnames from 'classnames'

export default class SeoProviderReviews extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: (this.props.tabs[0] && this.props.tabs[0].code) || ''
        }
    }

    toggle(e, tab) {
        e.preventDefault();
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    render() {
        return (
            <Card className="mb-4">
                <CardBody>
                    <Nav tabs>
                        {this.props.tabs.map(tab =>
                            <NavItem key={`tab_${tab.code}`}>
                                <NavLink href="#"
                                    className={classnames({ active: this.state.activeTab === tab.code })}
                                    onClick={(e) => this.toggle(e, tab.code)}
                                    >
                                    {tab.name}
                                </NavLink>
                            </NavItem>
                        )}
                    </Nav>
                    <TabContent activeTab={this.state.activeTab}>
                        {this.props.tabs.map(tab =>
                            <TabPane key={`pane_${tab.code}`} tabId={tab.code}>
                                {tab.reviews.map(review =>
                                    <div key={review.id}>
                                        <p className="mt-4 mb-1">{review.message}</p>
                                        <div className="clearfix">
                                            <div className="float-left text-nowrap font-weight-600">
                                                {review.name}
                                            </div>
                                            <div className="float-right text-nowrap font-weight-600">
                                                {parseFloat(review.rating || 0).toFixed(2)}/10
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </TabPane>
                        )}
                    </TabContent>
                </CardBody>
            </Card>
        )
    }
}